import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { uploadUmiResultsFile } from 'src/redux/slices/project/endpoints'
import { Scenario } from 'src/types/database-model'

import { Button, IconButton, Typography } from '@material-ui/core'
import CachedIcon from '@material-ui/icons/Cached'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

///// Types
type DropzoneResultsProps = {
  scenario: Scenario
}

///// Components
const DropzoneResults: React.FC<DropzoneResultsProps> = ({ scenario }) => {
  const [trigger, { data: fileUploadData, isLoading: isUploadingResults }] =
    uploadUmiResultsFile.useMutation({ fixedCacheKey: 'uploadResultsUmiFile' })

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      acceptedFiles.forEach(async (file) => {
        trigger({ ...scenario, file })
      })
    },
    [trigger, scenario],
  )

  const { getRootProps, getInputProps, acceptedFiles, isDragActive } = useDropzone({
    accept: '.umi',
    maxFiles: 1,
    onDrop,
  })

  return (
    <div {...getRootProps()}>
      {!scenario.results_umi_file_location && (
        <Button
          variant='outlined'
          size='small'
          color='primary'
          endIcon={<CloudUploadIcon />}
          disabled={isUploadingResults}
        >
          Upload Results
        </Button>
      )}
      {scenario.results_umi_file_location && (
        <>
          <Typography variant='overline'>
            Results File: {`v${String(scenario.results_umi_file_version).padStart(2, '0')}`}
          </Typography>
          <IconButton size='small' disabled={isUploadingResults}>
            {scenario.results_umi_file_location ? <CachedIcon /> : <CloudUploadIcon />}
          </IconButton>
        </>
      )}
      <input {...getInputProps()} />
    </div>
  )
}

export default DropzoneResults
